import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';

const AutoSaveIndicator = ({ lastSaved, isSaving }) => {
  const [timeAgo, setTimeAgo] = useState('');

  useEffect(() => {
    if (!lastSaved) return;

    const updateTimeAgo = () => {
      const now = new Date();
      const diff = Math.floor((now - lastSaved) / 1000);

      if (diff < 60) {
        setTimeAgo('hace unos segundos');
      } else if (diff < 3600) {
        const minutes = Math.floor(diff / 60);
        setTimeAgo(`hace ${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}`);
      } else {
        const hours = Math.floor(diff / 3600);
        setTimeAgo(`hace ${hours} ${hours === 1 ? 'hora' : 'horas'}`);
      }
    };

    updateTimeAgo();
    const interval = setInterval(updateTimeAgo, 30000);

    return () => clearInterval(interval);
  }, [lastSaved]);

  if (isSaving) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-primary/10 border border-primary/20">
        <div className="animate-spin">
          <Icon name="RefreshCw" size={16} className="text-primary" />
        </div>
        <span className="text-sm caption text-primary">Guardando...</span>
      </div>
    );
  }

  if (lastSaved) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-success/10 border border-success/20">
        <Icon name="CheckCircle2" size={16} className="text-success" />
        <span className="text-sm caption text-success">
          Guardado {timeAgo}
        </span>
      </div>
    );
  }

  return null;
};

export default AutoSaveIndicator;